export const ImageFileTypes = {
    AGRONOMY_REFERENCE_SHEET: "agronomy_reference_sheet_image",
    BLANK: "blank_image",
    COVER_BACK: "cover_back",
    COVER_FRONT: "cover_front",
    COVER_PRINT: "cover_print",
    COVER_THUMBNAIL: "cover_thumbnail",
    PRODUCT_BRANDING: "product_branding",
    PRODUCT_BRANDING_WHITE: "product_branding_white",
    COMPLIMENTARY_LOGO: "complimentary_logo",
    COVER_PHOTO: "cover_photo",
    FILLER_IMAGE: "filler_image",
    POSTCARD_IMAGE: "postcardUpload",
    POSTER_IMAGE: "poster_image",
    POSTER_IMAGE_WEB: "web_image",
    PRODUCT_LOGO: "product_logo",
    PRODUCT_IMAGE: "product_image",
    PRODUCT_ICON: "product_icon",
    PRODUCT_RECOMMENDED_IMAGES: "recommended_images",
    TECH_SHEET: "seed_tech_sheet_image",
    SEED_DIVIDER: "seed_separator",
    SHELF_DIVIDER: "shelf_separator",
    SEED_ICON: "seed_icon",
};



// WEBPACK FOOTER //
// ./src/infrastructure/ImageFileTypes.ts